import { BROADCAST_CANCEL_SOURCE_DISCONNECT } from 'actions/Types';

export default sourceId => {
  return dispatch => {
    const action = {
      type: BROADCAST_CANCEL_SOURCE_DISCONNECT,
      payload: { sourceId }
    };

    dispatch(action);
  };
};
